export const $_GET = (k) => {
  return new URL(document.location).searchParams.get(k);
};

export const trans = (text, vars) => {
  let translation;
  if (text.length < 1) {
    console.error("Received empty translation request :S");
    console.trace();
    translation = text;
  } else if (typeof window.translations[text] === "undefined") {
    console.error("Missing JS translation", text);
    translation = text;
  } else {
    translation = window.translations[text];
  }

  if (typeof vars === "object") {
    Object.keys(vars).forEach((key) => {
      translation = translation.replaceAll("%" + key + "%", vars[key]);
    });
  }

  return translation;
};

window.trans = trans;
window.$_GET = $_GET;
